module.exports = __webpack_public_path__ + "static/media/Design_system.16c0fa5a.png";